var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{class:_vm.myClass,attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._v("\n        "+_vm._s(_vm.text.split("=")[0])),_c('br'),_vm._v(_vm._s(_vm.text.split("=")[1])+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }